import { PaymentCardImageTypes } from '@mews/framework';
import { PaymentMethodImageType } from './types';

export const getSourceImageByType = (type: PaymentMethodImageType | keyof PaymentCardImageTypes) => `${type}.svg`;
